import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  actionsColumnHeader: {
    defaultMessage: 'Actions',
    description: 'Header for the actions column of a table',
    id: 'mg2yPT',
  },
  resendVerification: {
    defaultMessage: 'Resend Verification',
    description: 'Label for a button to resend a verification email',
    id: 'ZM16/N',
  },
  domainSettingsMenuItem: {
    defaultMessage: 'Domain Settings',
    description: 'Menu item to view settings for a domain',
    id: '+i/5CF',
  },
  copyToClipboardButtonLabel: {
    defaultMessage: 'Copy to clipboard',
    description: 'Label for a button to copy text to the clipboard',
    id: 'GNGL5Q',
  },
  unsupported: {
    defaultMessage: 'Unsupported',
    description: 'Domain authentication status for a domain that does not support authentication',
    id: 'rlXbu4',
  },
  pending: {
    defaultMessage: 'Pending',
    description: 'Domain authentication status for a domain that is pending authentication',
    id: 'FKnA3v',
  },
  authenticated: {
    defaultMessage: 'Authenticated',
    description: 'Domain authentication status for an authenticated domain',
    id: 'G8ZIFB',
  },
  unauthenticated: {
    defaultMessage: 'Unauthenticated',
    description: 'Domain authentication status for an unauthenticated domain',
    id: 'MRK2H8',
  },
  verified: {
    defaultMessage: 'Verified',
    description: 'Email verification status for a verified email address',
    id: 'WNCehH',
  },
  authenticateDomainLabel: {
    defaultMessage: 'Authenticate Domain',
    description: 'Label for a button to authenticate a domain',
    id: 'Y/Wjgj',
  },
  emailAddressColumnHeader: {
    defaultMessage: 'Email Address',
    description: 'Header for the email address column of a table',
    id: 'ec/UqN',
  },
  emailStatusColumnHeader: {
    defaultMessage: 'Email Status',
    description: 'Header for the email status column of a table',
    id: 'r5Xgzp',
  },
  domainStatusColumnHeader: {
    defaultMessage: 'Domain Authentication',
    description: 'Header for the domain authentication column of a table',
    id: 'f5aXpK',
  },
  storeColumnHeader: {
    defaultMessage: 'Store',
    description: 'Header for the store column of a table',
    id: 'i4kcBP',
  },
  verifyEmail: {
    defaultMessage: 'Verify Email',
    description: 'Label for a button to verify an email address',
    id: 'gJz2Ad',
  },
  removeDomainError: {
    defaultMessage: 'Failed to remove domain',
    description: 'Error message when removing a domain fails',
    id: 'Jq+AuY',
  },
  domainAuthenticationHeaderTooltip: {
    defaultMessage: 'Public domain addresses (like gmail.com) cannot be authenticated because you do not own the domain.',
    description: 'Tooltip for the domain authentication header stating that public domains can not be authenticated',
    id: 'ak1K7o',
  },
});
